"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Label = _interopRequireDefault(require("./Label"));

require("../styles/styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const TextArea = props => {
  const {
    label,
    id,
    hidden,
    labelHidden,
    className = "",
    labelClassName = "",
    labelPosition
  } = props,
        rest = _objectWithoutProperties(props, ["label", "id", "hidden", "labelHidden", "className", "labelClassName", "labelPosition"]);

  const textAreaClassname = `${hidden ? "ric-hidden" : ""} ${className} ric-textarea`;
  return _react.default.createElement(_react.Fragment, null, labelPosition === "before" && _react.default.createElement(_Label.default, {
    className: `${labelClassName} ${labelHidden ? "ric-hidden" : ""}`,
    htmlFor: id
  }, label), _react.default.createElement("textarea", _extends({
    id: id
  }, rest, {
    className: textAreaClassname
  })), labelPosition === "after" && _react.default.createElement(_Label.default, {
    className: `${labelClassName} ${labelHidden ? "ric-hidden" : ""}`,
    htmlFor: id
  }, label));
};

TextArea.propTypes = {
  hidden: _propTypes.default.bool,
  label: _propTypes.default.string.isRequired,
  id: _propTypes.default.string.isRequired,
  placeholder: _propTypes.default.string,
  labelPosition: _propTypes.default.string,
  labelClassName: _propTypes.default.string,
  labelHidden: _propTypes.default.bool
};
TextArea.defaultProps = {
  placeholder: "",
  labelPosition: "before"
};
var _default = TextArea;
exports.default = _default;